import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { login as loginApi } from '@/shared/api/authApi';
import { useAuthStore } from '@/shared/stores/authStore';
import type { LoginCredentials } from '@/shared/types';

export function useLogin() {
  const setAuth = useAuthStore(state => state.setAuth);
  const [error, setError] = useState<string | null>(null);

  const mutation = useMutation({
    mutationFn: (credentials: LoginCredentials) => loginApi(credentials),
    onSuccess: ({ user, token }) => {
      setAuth(user, token);
      setError(null);
    },
    onError: (err: Error) => {
      setError(err.message || 'Error al iniciar sesión');
    },
  });

  return {
    login: mutation.mutateAsync,
    isLoading: mutation.isPending,
    error,
  };
}
